import React, { useEffect, useState } from "react";
import { Parcel } from "../../../model/parcel";
import { AnnounceParcelTrackerForm } from "./announce-parcel-tracker-form";

interface IAnnounceParcelTrackerAssignmentControllerProps {
    parcelsList: Parcel[];
    onFormSubmit: () => Promise<void>;
    onClose: () => void;
}

export const AnnounceParcelTrackerAssignmentController = (props: IAnnounceParcelTrackerAssignmentControllerProps) => {
    const [parcelsList, setParcelsList] = useState<Parcel[]>(props.parcelsList);
    const [activeParcel, setActiveParcel] = useState<Parcel>(props.parcelsList[0]);

    const handleParcelCompleted = async () => {
        setParcelsList(prev => prev.filter(parcel => parcel.parcelId !== activeParcel?.parcelId));

        await props.onFormSubmit();
    };

    useEffect(() => {
        if (parcelsList.length === 0) {
            props.onClose();

            return;
        }

        setActiveParcel(parcelsList[0]);
    }, [parcelsList]);

    return <AnnounceParcelTrackerForm parcel={activeParcel}
                                      parcelCount={props.parcelsList.length}
                                      remainingParcelCount={parcelsList.length}
                                      onSkip={handleParcelCompleted}
                                      onFormSubmit={handleParcelCompleted}
                                      onCancel={props.onClose} />;
};
